// extracted by mini-css-extract-plugin
export default {"container":"allcards_container__Pv3kn","adoptar":"allcards_adoptar__tN66v","body":"allcards_body__i-apl"};